import styled, { css } from 'styled-components';

import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import {
  DefaultStyledProps,
  SUPPORTED_COMPONENTS,
  SUPPORTED_PROPERTIES,
} from '@savgroup-front-common/types';

import { styledGetCustomComponentProperty } from '../../../../helpers';
import { fontStyle } from '../../../../theme/helpers/fontStyle';

interface GetTextColorProps extends DefaultStyledProps {
  isError?: boolean;
}

const getTextColor = (props: GetTextColorProps) => {
  const { theme } = props;

  if (props.isError) {
    return theme.colors.danger;
  }

  return theme.newUI.defaultColors.secondaryText;
};

interface LabelWrapProps {
  fullWidth?: boolean;
  isHorizontal?: boolean;
}

export const $LabelWrap = styled.div<LabelWrapProps>`
  display: flex;
  height: ${spacing('xl')};
  align-items: center;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'fit-content')};
  margin-bottom: ${({ isHorizontal }) =>
    isHorizontal ? 'unset' : spacing('xs')};
`;

interface LabelStyledProps extends DefaultStyledProps {
  isError: boolean;
  isHorizontal: boolean;
  $isRequired?: boolean;
  fullWidth?: boolean;
  $isMultiLine?: boolean;
}
export const $LabelStyled = styled.label<LabelStyledProps>`
  display: flex;
  align-items: center;
  font-size: ${styledGetCustomComponentProperty({
    componentName: SUPPORTED_COMPONENTS.DEFAULT_LABEL,
    property: SUPPORTED_PROPERTIES.FONT_SIZE,
  })};
  font-weight: ${styledGetCustomComponentProperty({
    componentName: SUPPORTED_COMPONENTS.DEFAULT_LABEL,
    property: SUPPORTED_PROPERTIES.FONT_WEIGHT,
  })};

  color: ${getTextColor};
  min-height: ${styledGetCustomComponentProperty({
    componentName: SUPPORTED_COMPONENTS.DEFAULT_LABEL,
    property: SUPPORTED_PROPERTIES.MIN_HEIGHT,
  })};
  margin: ${({ isHorizontal }) => (isHorizontal ? 'unset' : 0)};

  > div {
    height: 100%;
  }
  svg {
    height: ${({ theme }) => theme.fonts.size.ultraSmall};
    max-width: ${({ theme }) => theme.fonts.size.ultraSmall};
    margin-right: ${spacing('sm')};
    color: ${({ theme }) => theme.colors.paragraphTextColor};
  }

  ${({ $isMultiLine }) => {
    if ($isMultiLine) {
      return css`
        & > * {
          white-space: normal;
        }
      `;
    }

    return css`
      & > * {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    `;
  }}

  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'inherit')};

  ${({ $isRequired }) => {
    if (!$isRequired) {
      return css``;
    }

    return css`
      &::after {
        margin-left: ${spacing('xs')};
        content: '*';
        color: ${({ theme }) => theme.colors.danger};
      }
    `;
  }}
`;

export const $LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('xs')};

  margin-bottom: ${spacing('sm')};

  & * {
    margin: 0;
  }
`;

export const $SubLabel = styled.span`
  ${fontStyle('xs')};
  font-weight: ${fontWeight('normal')};
  color: ${({ theme }) => theme.newUI.defaultColors.secondaryText};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
